import _ from 'lodash';
import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_PROCESSED_WARRANTY = {
  'processedWarrantyList': [],
  'loading': false,
  'fileData': [],
  'warrantySequences': [],
  'warrantyStatus': [],
};

const addCheckedField = (list) => {
  const newList = [...list];
  newList.map((element) => {
    return (element.checked = false);
  });
  return newList;
};

const changeCheckedStatus = (list, warrantyCode, checked) => {
  const newList = [...list];
  const index = _.findIndex(newList, function(element) {
    return element.code === warrantyCode;
  });

  const newObject = {...newList[index]};
  newObject.checked = checked;
  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
};

const changeAllCheckedStatus = (list, rows, checked) => {
  const newList = list.map((warranty) => {
    const newObject = rows.find(({original}) => original.code === warranty.code);
    if (newObject && newObject.checked !== checked) {
      return {
        ...warranty,
        'checked': checked,
      };
    }
    return warranty;
  });

  return newList;
};

export const processedWarranty = (state, action) => {
  return createReducer(INITIAL_STATE_PROCESSED_WARRANTY, {
    [ActionTypes.FETCHING_TWC_LIST]: (state, action) => ({
      ...state,
      'loading': true,
      'fileData': [],
    }),
    [ActionTypes.FETCHED_TWC_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'processedWarrantyList': [],
    }),
    [ActionTypes.FETCHED_TWC_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'processedWarrantyList': addCheckedField(action.response.data),
    }),
    [ActionTypes.FETCHING_WARRANTY_SEQUENCES]: (state, action) => ({
      ...state,
      'loading': true,
      'warrantySequences': [],
    }),
    [ActionTypes.FETCHED_WARRANTY_SEQUENCES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'warrantySequences': [],
    }),
    [ActionTypes.FETCHED_WARRANTY_SEQUENCES]: (state, action) => ({
      ...state,
      'loading': false,
      'warrantySequences': action.response.data,
    }),
    [ActionTypes.FETCHING_WARRANTY_STATUS]: (state, action) => ({
      ...state,
      'loading': true,
      'warrantyStatus': [],
    }),
    [ActionTypes.FETCHED_WARRANTY_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'warrantyStatus': [],
    }),
    [ActionTypes.FETCHED_WARRANTY_STATUS]: (state, action) => ({
      ...state,
      'loading': false,
      'warrantyStatus': action.response.data,
    }),
    [ActionTypes.FETCHING_FILE_DATA]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_FILE_DATA_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'fileData': [],
    }),
    [ActionTypes.FETCHED_FILE_DATA]: (state, action) => ({
      ...state,
      'loading': false,
      'fileData': action.response.data,
    }),
    [ActionTypes.ADD_WARRANTY_CHECKED]: (state, action) => {
      const newList = changeCheckedStatus(
        state.processedWarrantyList,
        action.payload,
        true
      );
      return {
        ...state,
        'processedWarrantyList': newList,
      };
    },
    [ActionTypes.REMOVE_WARRANTY_CHECKED]: (state, action) => {
      const newList = changeCheckedStatus(
        state.processedWarrantyList,
        action.payload,
        false
      );
      return {
        ...state,
        'processedWarrantyList': newList,
      };
    },
    [ActionTypes.ADD_ALL_WARRANTY_CHECKED]: (state, action) => {
      const newList = changeAllCheckedStatus(
        state.processedWarrantyList,
        action.payload,
        true
      );
      return {
        ...state,
        'processedWarrantyList': newList,
      };
    },
    [ActionTypes.REMOVE_ALL_WARRANTY_CHECKED]: (state, action) => {
      const newList = changeAllCheckedStatus(
        state.processedWarrantyList,
        action.payload,
        false
      );
      return {
        ...state,
        'processedWarrantyList': newList,
      };
    },
    [ActionTypes.CLEAR_TWC_LIST]: (state, action) => ({
      ...state,
      'processedWarrantyList': [],
    }),
    [ActionTypes.UPDATING_TWC_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_TWC_LIST]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_TWC_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
